import * as ActionsType from "../../actions/widget";

const initialState = {
  activeWidgetId: null,
  activeWidgetSportId: null,
  name: '',
};

export default function betradarReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ActionsType.SET_RADAR_WIDGET:
      return {
        ...state,
        activeWidgetId: action.data.radarId,
        activeWidgetSportId: action.data.sportId,
        name: action.data.name,
      };
    case ActionsType.REMOVE_RADAR_WIDGET:
      window.radarWidget.stop();
      return {
        ...state,
        activeWidgetId: null
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/betradarReducer.js